import React, { useState } from "react";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <header className="navbar">

      {/* =========================
          LOGO
      ========================== */}
      <a href="/" className="logo" onClick={closeMenu}>
        <img
          src="/images/logo.png"
          alt="PRT Academy IT Training Institute in Hyderabad"
        />

        <span className="tagline">
          Training | Internship | Placement
        </span>
      </a>


      {/* =========================
          DESKTOP / MOBILE LINKS
      ========================== */}
      <nav className={`nav-links ${isOpen ? "open" : ""}`}>

        <a href="#why-prt" onClick={closeMenu}>
          Support We Offer
        </a>

        <a href="#career-pathway" onClick={closeMenu}>
          Your Journey
        </a>

        <a href="#courses" onClick={closeMenu}>
          Our Courses
        </a>

      </nav>


      {/* =========================
          MOBILE MENU
      ========================== */}
      <button
        type="button"
        className={`hamburger ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle navigation menu"
        aria-expanded={isOpen}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>

    </header>
  );
};

export default Navbar;